import $ from "jquery";
import React, {useEffect, useState} from "react";
import "../styles/css/admin-style.css"
import {userService} from "../services/userService";
import KeywordDropdownSearchForm from "../shared/components/KeywordDropdownSearchForm";
import eventEmitter from "../shared/eventEmitter";
import {EventEmitterTypes} from "../shared/eventEmitterEnum";
import TableWithActionsDropdown, {Column} from "../shared/components/TableWithActionsDropdown";
import {Badge, Dropdown} from "react-bootstrap";
import {authService} from "../services/authService";
import NotificationService from "../services/NotificationService";
import EditUserModal from "../components/super-admin-management/EditUserModal";
export interface Admin {
    email: string;
    firstName: string,
    lastName: string,
    inactive: false,
    userId: string
}
const SuperAdminManagementPage: React.FC = () => {
    const [userData, setUserData] = useState([])
    const [searchKeywords, setSearchKeywords] = useState([])
    const [dropDownOptions, setDropdownOptions] = useState(["Active", "Inactive", "All"])
    const [activeDropdown, setActiveDropdown] = useState("Active")

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [currentAdmin, setCurrentAdmin] = useState<Admin>();
    const toggleModal = () => {
        setIsModalVisible(!isModalVisible);
    }

    useEffect(() => {
        onSearch();
    }, []);

    useEffect(() => {
        const refreshListener = () => {
            onSearch();
        };

        eventEmitter.on(EventEmitterTypes.REFRESH_USERS, refreshListener);

        return () => {
            eventEmitter.off(EventEmitterTypes.REFRESH_USERS, refreshListener);
        };
    }, []);

    const onSearch = () => {
        Promise.resolve(
            userService.searchUsers(searchKeywords, activeDropdown === "All" ? null : activeDropdown === "Inactive")
        ).then(postRes => {
            setUserData(postRes.users || []);
            return postRes;
        });
    }

    const columns: Column<Admin>[] = [
        {
            label: "Name",
            varName: "lastName",
            render: (a) => `${a.firstName} ${a.lastName}`,
        },
        {
            label: "Email",
            varName: "email",
            render: (a) => <a href="#">{a.email}</a>,
        },
        {
            label: "Status",
            varName: "inactive",
            sortable: false,
            render: (a) => (
                <Badge bg={a.inactive ? "danger" : "success"}>
                    {a.inactive ? "Inactive" : "Active"}
                </Badge>
            ),
        },
    ];


    return (
        <>
            <div className="container-fluid ptCustom">
                <div className="row">
                    <div className="col-12 my-2">
                        <div className="card shadow-sm rounded-lg">
                            <div className="card-body p-4">
                                <KeywordDropdownSearchForm searchKeywords={searchKeywords} DropdownOptions={dropDownOptions} onSearch={onSearch} setSearchKeywords={setSearchKeywords} activeDropdown={activeDropdown} setActiveDropdown={setActiveDropdown}/>
                                <TableWithActionsDropdown
                                    data={userData}
                                    columns={columns}
                                    defaultSortDesc={false}
                                    actions={(admin) => (
                                        <><Dropdown.Item
                                            href="#"
                                            data-bs-toggle="modal"
                                            data-bs-target="#userModal"
                                            onClick={() => {
                                                toggleModal();
                                                setCurrentAdmin(admin);
                                            }}
                                        >
                                            <i className="fa-light fa-pencil fa-fw"></i> Edit Admin
                                        </Dropdown.Item><Dropdown.Item onClick={async () => {
                                            try {
                                                await authService.forgotPassword(admin.email);
                                                NotificationService.success("Reset password email sent successfully");
                                            } catch (error) {
                                            }
                                        }}>
                                            <i className="fa-light fa-key fa-fw"></i> Send Password Reset
                                        </Dropdown.Item></>
                                    )}
                                />

                                <EditUserModal
                                    toggle={toggleModal}
                                    show={isModalVisible}
                                    user={currentAdmin}
                                    refreshData={onSearch}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SuperAdminManagementPage;
